(function () {
  function mountBannerFourContent() {
    var slide = document.querySelector('#shopify-section-home #anHero.hero .hero-slide:nth-child(4)');
    if (!slide || slide.querySelector('.an-hero-copy-layer--ritual')) return;

    var scrim = document.createElement('div');
    scrim.className = 'an-hero-copy-scrim an-hero-copy-scrim--ritual';
    scrim.setAttribute('aria-hidden', 'true');

    var layer = document.createElement('div');
    layer.className = 'an-hero-copy-layer an-hero-copy-layer--ritual';
    layer.innerHTML = [
      '<div class="an-hero-copy an-hero-copy--ritual">',
      '<h2 aria-label="Complete The Ritual">',
      '<span class="an-hero-title-plain">Complete</span>',
      '<span class="an-hero-title-accent">The Ritual.</span>',
      '</h2>',
      '<p><span>Fragrance is more than a scent.</span><span>It&rsquo;s the final touch.</span></p>',
      '<a class="an-hero-cta an-hero-cta--ritual" href="/collections/all">Shop Now</a>',
      '</div>'
    ].join('');

    slide.appendChild(scrim);
    slide.appendChild(layer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountBannerFourContent);
  } else {
    mountBannerFourContent();
  }

  window.addEventListener('pageshow', mountBannerFourContent);
  document.addEventListener('shopify:section:load', mountBannerFourContent);
})();
